const actions = {
  CREATE_MEMBER_CAMPAIGN: 'CREATE_MEMBER_CAMPAIGN',
  CREATE_MEMBER_CAMPAIGN_ENDED: 'CREATE_MEMBER_CAMPAIGN_ENDED',
  SEARCH_MEMBER_CAMPAIGNS: 'SEARCH_MEMBER_CAMPAIGNS',
  SEARCH_MEMBER_CAMPAIGNS_ENDED: 'SEARCH_MEMBER_CAMPAIGNS_ENDED',
  UPDATE_MEMBER_CAMPAIGN: 'UPDATE_MEMBER_CAMPAIGN',
  UPDATE_MEMBER_CAMPAIGN_ENDED: 'UPDATE_MEMBER_CAMPAIGN_ENDED',
  DELETE_MEMBER_CAMPAIGNS: 'DELETE_MEMBER_CAMPAIGNS',
  DELETE_MEMBER_CAMPAIGNS_ENDED: 'DELETE_MEMBER_CAMPAIGNS_ENDED',
  TRIGGER_MEMBER_CAMPAIGN: 'TRIGGER_MEMBER_CAMPAIGN',
  TRIGGER_MEMBER_CAMPAIGN_ENDED: 'TRIGGER_MEMBER_CAMPAIGN_ENDED',
  SEARCH_MEMBER_CAMPAIGN_MEMBER_RECORDS: 'SEARCH_MEMBER_CAMPAIGN_MEMBER_RECORDS',
  SEARCH_MEMBER_CAMPAIGN_MEMBER_RECORDS_ENDED: 'SEARCH_MEMBER_CAMPAIGN_MEMBER_RECORDS_ENDED',
  SEARCH_MEMBER_CAMPAIGN_TAG_MEMBER_RECORDS: 'SEARCH_MEMBER_CAMPAIGN_TAG_MEMBER_RECORDS',
  SEARCH_MEMBER_CAMPAIGN_TAG_MEMBER_RECORDS_ENDED:
    'SEARCH_MEMBER_CAMPAIGN_TAG_MEMBER_RECORDS_ENDED',
  SEARCH_TRIGGER_RECORDS: 'SEARCH_TRIGGER_RECORDS',
  SEARCH_TRIGGER_RECORDS_ENDED: 'SEARCH_TRIGGER_RECORDS_ENDED',
  GET_MEMBER_CAMPAIGN_TRIGGER_RECORD_STATISTICS: 'GET_MEMBER_CAMPAIGN_TRIGGER_RECORD_STATISTICS',
  GET_MEMBER_CAMPAIGN_TRIGGER_RECORD_STATISTICS_ENDED:
    'GET_MEMBER_CAMPAIGN_TRIGGER_RECORD_STATISTICS_ENDED',
};

export default actions;
